import type { EntityAvatarEntityType } from "./entityAvatar.types";

export const entityAvatarQueryKeys = {
  detail: (entityType: EntityAvatarEntityType, entityId: number) =>
    ["entityAvatar", "detail", entityType, entityId] as const,
  enrichUser: (id: number) => ["entityAvatar", "enrich", "user", id] as const,
  enrichTeam: (id: number) => ["entityAvatar", "enrich", "team", id] as const,
  wikipediaSummary: (issueName: string) => ["entityAvatar", "wikipedia", issueName] as const,
  issueThumb: (issueName: string) => ["entityAvatar", "issueThumb", issueName] as const,
  crosspostTarget: (targetType: string, targetId: number | string) =>
    ["entityAvatar", "crosspostTarget", targetType, targetId] as const,
};
